<template>
  <div class="groupMemberDiv">
    <div class="label" style="margin-bottom: 10px">{{ groupName }}</div>
    <div class="group-member-list">
      <div class="group-member" v-for="(item, index) in groupMemberList" :key="index">
        <div class="avatar-wrap">
          <UserAvatar class="avatar" :url="item.avatar" :name="item.nickName" @click="showDialog(item)"/>
          <div v-if="item.removeAuth" class="el-icon-remove group-member-remove-btn" @click="removeMember(item)"></div>
        </div>
        <div class="member-info">
          <div class="name"><span class="value">{{ item.nickName }}</span></div>
          <div class="projectRole">{{ item.projectRoleName || '协同成员' }}</div>
        </div>
      </div>
      <el-button v-if="canAddGroupMemberFlag" class="group-member-add-btn" type="primary" icon="el-icon-plus" @click="showDialog(null)"></el-button>
    </div>
    <!-- 添加团队成员 -->
    <el-dialog :title="dialogTitle" :visible.sync="addGroupMemberVisible" width="550px" append-to-body :close-on-click-modal="false">
      <el-form :model="addGroupMemberModel" :rules="addGroupMemberFormRules" ref="addGroupMemberForm" label-width="100px">
        <el-form-item label="部门：" prop="deptId">
          <treeSelect v-model="addGroupMemberModel.deptId" :options="deptOptions" @select="deptSelect" @open="deptOpen" :defaultExpandLevel="2"
                      :show-count="true" placeholder="请选择部门" :disabled="deptSelectDisabled"/>
        </el-form-item>
        <el-form-item label="人员：" prop="userId">
          <el-select ref="groupUserSelectRef" v-model="addGroupMemberModel.userId" clearable filterable placeholder="请选择人员" style="width: 100%" :disabled="userSelectDisabled">
            <el-option v-for="item in userOptions"
                       :key="item.userId" :label="item.nickName+'（'+item.phonenumber+'）'" :value="item.userId"/>
          </el-select>
        </el-form-item>
        <el-form-item label="项目角色：" prop="projectRoleId">
          <el-select ref="projectRoleSelectRef" v-model="addGroupMemberModel.projectRoleId" clearable filterable placeholder="请选择项目角色" style="width: 100%">
            <el-option v-for="item in projectRoleOptions"
                       :key="item.projectRoleId" :label="item.projectRoleName" :value="item.projectRoleId"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="clearForm">取消</el-button>
            <el-button type="primary" @click="confirmAddGroupMember">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {treeSelectWithOutDataScope} from "@/api/system/dept";
import {addMember, queryMemberList, removeMember} from "@/api/crm/contract";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import UserSelect from "@/views/crm/components/userSelect";
import {listUserWithOutDataScope} from "@/api/system/user";
import UserAvatar from '@/views/system/user/userAvatar'

export default {
  name: "groupMember",
  props: {
    groupName: {
      type: String,
      default: "团队"
    },
    targetId: {
      type: Number,
      default: null
    },
    targetType: {
      type: String,
      default: ""
    },
    canAddGroupMemberFlag: {
      type: Boolean,
      default: false
    },
  },
  components: {
    UserSelect,
    TreeSelect,
    UserAvatar
  },
  data() {
    return {
      groupMemberList: [],
      addGroupMemberVisible: false,
      addGroupMemberModel: {
        targetId: this.targetId,
        targetType: this.targetType,
        deptId: null,
        userId: null,
        projectRoleId: null,
        saveOrUpdate : true
      },
      deptOptions: [],
      userOptions: [],
      projectRoles: [{
        projectRoleId: 1,
        projectRoleName: '合伙人'
      }, {
        projectRoleId: 2,
        projectRoleName: '项目经理'
      }, {
        projectRoleId: 3,
        projectRoleName: '销售'
      }],
      purchaseProjectRoles: [{
        projectRoleId: 1,
        projectRoleName: '采购协同'
      }, {
        projectRoleId: 2,
        projectRoleName: '仓管验收'
      }, {
        projectRoleId: 3,
        projectRoleName: '技术复核'
      }, {
        projectRoleId: 4,
        projectRoleName: '财务协同'
      }],
      addGroupMemberFormRules: {
        deptId: [
          {required: true, message: '请选择部门', trigger: 'blur'}
        ],
        userId: [
          {required: true, message: '请选择人员', trigger: 'blur'}
        ],
        projectRoleId: [
          {required: true, message: '请选择项目角色', trigger: 'blur'}
        ]
      },
      deptSelectDisabled: false,
      userSelectDisabled: false,
      dialogTitle : '添加团队成员'
    }
  },
  created() {
    this.queryGroupMemberList()
    this.getTreeselect()
  },
  computed: {
    projectRoleOptions() {
      return this.targetType === 'purchaseApply' ? this.purchaseProjectRoles : this.projectRoles
    }
  },
  methods: {
    queryGroupMemberList () {
      queryMemberList({
        targetId: this.targetId,
        targetType: this.targetType
      }).then(response => {
        this.groupMemberList = response.data || []
      })
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeSelectWithOutDataScope().then(response => {
        this.deptOptions = response.data;
      });
    },
    confirmAddGroupMember () {
      this.$refs["addGroupMemberForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          this.addGroupMemberModel.targetId = this.targetId
          addMember(this.addGroupMemberModel).then(response => {
            this.queryGroupMemberList()
            this.$emit('success', this.addGroupMemberModel.userId)
            this.msgSuccess("操作成功");
            this.clearForm()
            this.addGroupMemberVisible = false
          }).finally(() => {
            loading.close()
          })
        }
      })
    },
    removeMember (member) {
      this.$confirm('确认移除该团队成员(' + member.nickName + ')吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        removeMember({
          targetId: this.targetId,
          targetType: this.targetType,
          userId: member.userId,
          projectRoleId: member.projectRoleId
        }).then(response => {
          this.queryGroupMemberList()
          this.$emit('success', member.userId)
          this.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
      });
    },
    deptSelect (node, instanceId) {
      this.userOptions = []
      this.addGroupMemberModel.userId = null
      listUserWithOutDataScope({deptId: node.id}).then(response => {
        this.userOptions = response.rows;
      });
    },
    deptOpen () {
      //this.$refs.groupUserSelectRef.blur()
    },
    clearForm () {
      this.resetForm('addGroupMemberForm')
      this.addGroupMemberVisible = false
    },
    showDialog (member) {
      this.resetForm('addGroupMemberForm')
      this.addGroupMemberVisible = true
      if(null != member) {
        this.addGroupMemberModel.saveOrUpdate = false //修改
        this.addGroupMemberModel.deptId = member.deptId
        this.userOptions = []
        listUserWithOutDataScope({deptId: member.deptId}).then(response => {
          this.userOptions = response.rows;
        })
        this.addGroupMemberModel.userId = member.userId
        this.addGroupMemberModel.projectRoleId = member.projectRoleId
        this.deptSelectDisabled = true
        this.userSelectDisabled = true
        this.dialogTitle = '修改项目角色'
      } else {
        this.addGroupMemberModel.saveOrUpdate = true //新增
        this.addGroupMemberModel.deptId = null
        this.addGroupMemberModel.userId = null
        this.userOptions = []
        this.addGroupMemberModel.projectRoleId = null
        this.deptSelectDisabled = false
        this.userSelectDisabled = false
        this.dialogTitle = '添加团队成员'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.groupMemberDiv {
  .group-member-list {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 12px;
    min-width: 0;
  }

  .group-member-add-btn {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    text-align: center;
    border-radius: 50%;
    padding: 0 0 0 2px;
  }

  .group-member {
    position: relative;
    display: flex;
    align-items: center;
    width: 142px;
    min-width: 0;
    height: 44px;

    .avatar-wrap {
      position: relative;
      flex: 0 0 40px;
      width: 40px;
      height: 40px;
    }

    .avatar {
      float: none;
    }

    .member-info {
      min-width: 0;
      margin-left: 8px;
    }

    .name,
    .projectRole {
      min-width: 0;
      line-height: 20px;
    }

    .value,
    .projectRole {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .projectRole {
      color: #8a97a6;
      font-size: 12px;
    }

    .group-member-remove-btn {
      cursor: pointer;
      position: absolute;
      top: -4px;
      right: -4px;
      z-index: 2;
      color: #303133;
      background: #fff;
      border-radius: 50%;
    }
  }

  ::v-deep .vue-treeselect__control-arrow,
  ::v-deep .vue-treeselect__x {
    width: 9px !important;
    height: 9px !important;
  }

  ::v-deep .vue-treeselect__menu-container {
    z-index: 3000;
  }
}
</style>
